require('./../bootstrap');
window.Vue = require('vue');
const moment = require('moment');
require('moment/locale/da');
/*const bugsnag = require('bugsnag-js');
const bugsnagClient = bugsnag('9b967fea46d1cdd5994877adb0c7a1eb');
const bugsnagVue = require('bugsnag-vue')*/


import VueRouter from 'vue-router';
import {routes} from './routes';
import store from './store';
import StripeAmountCalculator from './../plugins/stripeAmountCalculator.js';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import AsyncComputed from 'vue-async-computed';
import Nl2br from 'vue-nl2br';
import Popup from './../general/popup.vue';

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

Bugsnag.start({
    apiKey: '9b967fea46d1cdd5994877adb0c7a1eb',
    plugins: [new BugsnagPluginVue()],
})

const BugsnagVue = Bugsnag.getPlugin('vue');
BugsnagVue.installVueErrorHandler(Vue);

const datepickerOptions = {
    sundayFirst: false,
    monthNames:[
        'Januar',
        'Februar',
        'Marts',
        'April',
        'Maj',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'December',
    ],
    days: ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'],
    daysShort: ['Man', 'Tir', 'Ons', 'Tors', 'Fre', 'Lør', 'Søn'],
    colors:{
        selected: '#B98C61',
    }
};
Vue.use(AirbnbStyleDatepicker, datepickerOptions);

Vue.use(VueRouter);
Vue.use(StripeAmountCalculator);
Vue.use(require('vue-moment'), {
    moment
});
Vue.use(AsyncComputed);
Vue.component('nl2br', Nl2br);


import Modal from './../general/modal.vue';
import Select from './../general/select.vue';

Vue.component('ws-modal', Modal);
Vue.component('ws-select', Select);
Vue.component('ws-popup', Popup);

import Manager from './manager.vue';

const router = new VueRouter({
    routes,
    scrollBehavior (to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ x: 0, y: 0 })
            }, 600)
        })
    }
});

const app = new Vue({
    el: '#app',
    router,
    store,
    components:{
        Manager
    },
});



//bugsnagClient.use(bugsnagVue(Vue));

